import { IBaseState } from "../../index";
import { NotificationModel } from "../../../models/report";


/**
 *
 */
export interface INotificationState extends IBaseState<{}, {}> {
  service?: {};
  reportNotification?: NotificationModel[];
}

/**
 * define report state by vuex
 */
export class NotificationState implements INotificationState {
  service?: {};
  reportNotification?: NotificationModel[];
  constructor(options: INotificationState) {
    this.service = options.service;
    this.reportNotification = [];
  }
}
